export default __webpack_public_path__ + "static/media/back.511903bc.svg";